import { TAB_CONTAINER_ACTIVE_CLASS } from './constants';
import { IListeners, ListenerType, MouseKeys } from './types';

let startX;
let scrollLeft;
let isScrolling;

export const MouseMoveActions = (tabsData) => {
  const disableMouseIsDown = () => {
    tabsData.tabContainerRef.classList.remove(TAB_CONTAINER_ACTIVE_CLASS);
    isScrolling = false;
  };

  const mouseIsDown = (e) => {
    isScrolling = true;
    tabsData.tabContainerRef.classList.add(TAB_CONTAINER_ACTIVE_CLASS);
    startX = e.pageX - tabsData.tabContainerRef.offsetLeft;
    scrollLeft = tabsData.tabContainerRef.scrollLeft;
  };

  const mouseMove = (e) => {
    if (!isScrolling) return;
    e.preventDefault();
    const x = e.pageX - tabsData.tabContainerRef.offsetLeft;
    const walk = x - startX;
    tabsData.tabContainerRef.scrollLeft = scrollLeft - walk;
  };

  const tabContainerRefListeners: IListeners<MouseKeys>[] = [
    {
      key: MouseKeys.mousedown,
      func: (e) => mouseIsDown(e),
      type: ListenerType.tabContainer,
    },
    {
      key: MouseKeys.mouseleave,
      func: disableMouseIsDown,
      type: ListenerType.tabContainer,
    },
    {
      key: MouseKeys.mouseup,
      func: disableMouseIsDown,
      type: ListenerType.tabContainer,
    },
    {
      key: MouseKeys.mousemove,
      func: (e) => mouseMove(e),
      type: ListenerType.tabContainer,
    },
  ];

  return { tabContainerRefListeners, isScrolling };
};
